// @mui
import { List, Box } from '@mui/material';
//
import { NavSectionProps } from '../type';
import NavList from './NavList';
import useAuth from 'src/hooks/useAuth';

// ----------------------------------------------------------------------

export default function NavSectionVertical({ navConfig, isCollapse, ...other }: NavSectionProps) {
  const { user } = useAuth();

  return (
    <Box {...other}>
      {navConfig.map((group) => (
        group.items.map((item, itemIndex) => {
          let validChildren: boolean = false;
          if (item.children) {
            const childAllowed = user && user.permission && item.children.map((x: any) => Object.keys(user.permission).includes(x.title.toLowerCase())).some((x: any) => x === true);
            const subheaderAllowed = user && user.permission ? Object.keys(user.permission).map(x => x.toLowerCase()).includes(group.subheader.toLowerCase()) : false;
            validChildren = childAllowed || subheaderAllowed;
          }
          else {
            validChildren = user && user.permission ? Object.keys(user.permission).map(x => x.toLowerCase()).includes(group.subheader.toLowerCase()) : false;
          }

          if (validChildren) {
            return (
              <List key={`${group.subheader}-${itemIndex}`} disablePadding sx={{ px: 2 }}>
                {
                  group.items.map((list) => (
                    <NavList
                      key={list.title + list.path}
                      data={list}
                      depth={1}
                      hasChildren={!!list.children}
                      isCollapse={isCollapse}
                    />
                  ))
                }
              </List>
            )
          }
          return null;
        })
      ))}
    </Box >
  );
}